import { SET_CONTACT_US_CONTENT } from "actions/types";

let initialState = {
  contactUsContent: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_CONTACT_US_CONTENT: {
      return {
        ...state,
        contactUsContent: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
